import { PostAPI } from 'Components/Helper/Helpers';

export const SelectBank = async (request) => {
    return PostAPI(request, 'OneClickAEPS/SelectBank');
};

export const CashWithdrawal = async (request) => {
    return PostAPI(request, 'OneClickAEPS/CashWithdrawal');
};

export const BalanceEnquiry = async (request) => {
    return PostAPI(request, 'OneClickAEPS/BalanceEnquiry');
};

export const MiniStatement = async (request) => {
    return PostAPI(request, 'OneClickAEPS/MiniStatement');
};

export const CheckUserAgentID = async (request) => {
    return PostAPI(request, 'OneClickAEPS/CheckUserAgentID');
};

export const UserOnbording = async (request) => {
    return PostAPI(request, 'OneClickAEPS/UserOnbording');
};

export const EKYCSendOTP = async (request) => {
    return PostAPI(request, 'OneClickAEPS/UserEKYCSendOTP');
};

export const USERValidateOTP = async (request) => {
    return PostAPI(request, 'OneClickAEPS/UserValidateOTP');
};

export const EKYCBiomateric = async (request) => {
    return PostAPI(request, 'OneClickAEPS/EKYCBiomatric');
};

export const TwoFactorAuthentication = async (request) => {
    return PostAPI(request, 'OneClickAEPS/TwoFactorAuthentication');
};

export const DailyMasterAuthentication = async (request) => {
    return PostAPI(request, 'OneClickAEPS/DailyMasterAuthentication');
}; 